export default __webpack_public_path__ + "static/media/select_user.9429a28b.png";